import { render, staticRenderFns } from "./RemoteFoodCarousel.vue?vue&type=template&id=62f38404&"
import script from "./RemoteFoodCarousel.vue?vue&type=script&lang=js&"
export * from "./RemoteFoodCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports